export const isAlphabetLetter = (letter: string): boolean =>
  letter.toLocaleLowerCase() >= 'a' && letter.toLocaleLowerCase() <= 'z';
